function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
/* eslint-disable no-unused-vars */
import mapboxgl from '!mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
import * as turf from '@turf/turf';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import ApolloClient from '../../apollo';
import MapInstance from '../../mappr';
import { dataItemDeselect, dataItemHover, dataItemHoverOff, dataItemLoad, dataItemsLoad } from '../../store/actions/datasetSlice';
import { geocoderClear, geocoderSearchFail, geocoderSelectDone } from '../../store/actions/geocoder';
import { changeMapBbox, mapDraw } from '../../store/actions/mapSlice';
import itemQuery from '../../store/queries/dataset';
import threeDUtils from '../../utils/3DLayerManager';
import { addAttributionControl, addMapCompassControl, addMapControls, addMapDrawControl, removeMapCompassControl } from '../../utils/mapUtils';
import { generateShortUrl as _generateShortUrl } from '../../store/actions/urlShortener';
import { add3dBuildingsLayer, addDataSetLayer, addJourneysLayer, addLayer, remove3DBuildingsLayer, removeJourneysLayer, setDataSetSource, switchBasemap, updateDatasetSource } from '../../utils/layersUtils';
import { getCityModels } from '../../utils/modelUtils';
import { getHash, setHash } from '../../utils/urlUtils';
import { getMobileOperatingSystem } from '../../utils/viewportUtils';
import { getCustomUrlParamList } from '../../utils/utils';
import { journeyDeselectStart } from '../../store/actions/navitiaSearch';
import { appLayoutModeDone } from '../../store/actions/appSlice';
mapboxgl.accessToken = 'pk.eyJ1IjoiYm9nZGFudmVjdHVlbCIsImEiOiJjaXN6dzcyd3UwMDY0MnRtbnk1cGVvZTlvIn0.ZHjWxqHO-CIfLNJXsFSZ2g';
var geocoderPopupContentElm = null;
var popup = null;
var marker = null;
var THREED_LAYER_PLACEHOLDER_ID = '3d-layer-placeholder';
var THREED_LAYER_ID = '3d-models-layer';

/** This component is used to render the map */
function Map(props) {
  var _map$current;
  var url = props.url,
    lng = props.lng,
    lat = props.lat,
    zoom = props.zoom,
    minZoom = props.minZoom,
    maxZoom = props.maxZoom,
    pitch = props.pitch,
    minPitch = props.minPitch,
    maxPitch = props.maxPitch,
    boundingBox = props.boundingBox,
    _props$models = props.models,
    models = _props$models === void 0 ? [] : _props$models,
    geocoderPopupComponent = props.geocoderPopupComponent,
    openStreetViewModal = props.openStreetViewModal,
    setMapReady = props.setMapReady,
    PopUpComponent = props.PopUpComponent,
    showPopup = props.showPopup,
    SecondaryLayerPopUpComponent = props.SecondaryLayerPopUpComponent,
    isMobile = props.isMobile,
    _props$isBboxIncluded = props.isBboxIncluded,
    isBboxIncluded = _props$isBboxIncluded === void 0 ? true : _props$isBboxIncluded,
    isSidebarCollapsable = props.isSidebarCollapsable,
    history = props.history,
    onBasemapChange = props.onBasemapChange;
  var dispatch = useDispatch();
  var ref = useRef(null);
  var compassControl = useRef(null);
  var moveInitiator = useRef(_moveInitiator);
  var setMoveInitiator = function setMoveInitiator(value) {
    moveInitiator.current = value;
    _setMoveInitiator(value);
  };
  var map = useRef();
  var threeDLayer = useRef();
  var lastZoom = useRef(null);
  var _useState = useState(),
    cityModelsList = _useState[0],
    setCityModelsList = _useState[1];
  var _useState2 = useState(''),
    _moveInitiator = _useState2[0],
    _setMoveInitiator = _useState2[1];
  var _useState3 = useState({}),
    lastPosition = _useState3[0],
    setLastPosition = _useState3[1];
  var _useState4 = useState(false),
    mapLoaded = _useState4[0],
    setMapLoaded = _useState4[1];
  var _useState5 = useState(null),
    urlCoords = _useState5[0],
    setUrlCoords = _useState5[1];
  var _useState6 = useState(null),
    urlParamName = _useState6[0],
    setUrlParamName = _useState6[1];
  var _useState7 = useState(false),
    flying = _useState7[0],
    setFlying = _useState7[1];
  var datasetBbox = useSelector(function (state) {
    var _state$dataset$data$i, _state$dataset, _state$dataset$data, _state$dataset$data$i2;
    return (_state$dataset$data$i = state === null || state === void 0 ? void 0 : (_state$dataset = state.dataset) === null || _state$dataset === void 0 ? void 0 : (_state$dataset$data = _state$dataset.data) === null || _state$dataset$data === void 0 ? void 0 : (_state$dataset$data$i2 = _state$dataset$data.info) === null || _state$dataset$data$i2 === void 0 ? void 0 : _state$dataset$data$i2.bbox) !== null && _state$dataset$data$i !== void 0 ? _state$dataset$data$i : null;
  });
  var _useSelector = useSelector(function (state) {
      return state.dataset && state.dataset.filters;
    }),
    selectedValues = _useSelector.selectedValues;
  var _useSelector2 = useSelector(function (state) {
      return state.dataset && state.dataset.search;
    }),
    searchMasks = _useSelector2.masks;
  var _useSelector3 = useSelector(function (state) {
      return state.dataset && state.dataset.filters;
    }),
    searchLoading = _useSelector3.loading,
    selectedMapViewFilter = _useSelector3.selectedMapViewFilter;
  var _useSelector4 = useSelector(function (state) {
      return state.dataset && state.dataset.selected;
    }),
    selectedItem = _useSelector4.item;
  var _useSelector5 = useSelector(function (state) {
      return state.dataset && state.dataset.hovered;
    }),
    hoveredItem = _useSelector5.item;
  var _useSelector6 = useSelector(function (state) {
      return state.dataset && state.dataset.navitiaSearch;
    }),
    journeys = _useSelector6.journeys;
  var _useSelector7 = useSelector(function (state) {
      return state.geocoder;
    }),
    geocoderSelectedItem = _useSelector7.item;
  var _useSelector8 = useSelector(function (state) {
      return state.urlShortener;
    }),
    shortUrl = _useSelector8.url;
  var _useSelector9 = useSelector(function (state) {
      return state.app;
    }),
    dataset = _useSelector9.dataset,
    project = _useSelector9.project,
    basemaps = _useSelector9.basemaps,
    language = _useSelector9.language,
    mprApiUrl = _useSelector9.mprApiUrl,
    mprTileUrl = _useSelector9.mprTileUrl;
  var filtersMap = useSelector(function (state) {
    if ((state === null || state === void 0 ? void 0 : state.dataset) && state.dataset.filters) {
      var _filtersMap = {};
      state.dataset.filters.filters.forEach(function (_) {
        _filtersMap[_.name] = _;
      });
      return _filtersMap;
    } else {
      return null;
    }
  });
  var _useSelector10 = useSelector(function (state) {
      return state.app.project.configs;
    }),
    streetViewLayers = _useSelector10.streetViewLayers,
    datasetsLayers = _useSelector10.datasetsLayers,
    geocoderCountries = _useSelector10.geocoderCountries,
    geocoderEnabled = _useSelector10.geocoderEnabled,
    displayDatasetLayerIcons = _useSelector10.displayDatasetLayerIcons,
    iconMapping = _useSelector10.iconMapping,
    iconFieldName = _useSelector10.iconFieldName,
    filterLogic = _useSelector10.filterLogic,
    mapIcons = _useSelector10.mapIcons,
    cityModels = _useSelector10.cityModels,
    cityModelsAndroid = _useSelector10.cityModelsAndroid,
    cityModelsIos = _useSelector10.cityModelsIos,
    mapboxAccessToken = _useSelector10.mapboxAccessToken,
    initiallyShowThreeD = _useSelector10.initiallyShowThreeD,
    initiallyShowThreeDMobile = _useSelector10.initiallyShowThreeDMobile,
    showPolygonSwitch = _useSelector10.showPolygonSwitch,
    showTargomoSwitch = _useSelector10.showTargomoSwitch;
  var _useSelector11 = useSelector(function (state) {
      return state.app;
    }),
    secondaryLayers = _useSelector11.secondaryLayers;
  var _useSelector12 = useSelector(function (state) {
      return state.app.activeLayers;
    }),
    activeSecondaryLayers = _useSelector12.secondary,
    activeStreetViewLayers = _useSelector12.streetView,
    activeBasemap = _useSelector12.basemap;
  var datasetLayersNames = useMemo(function () {
    var tmp = [dataset.id + "_feature_circle_default", dataset.id + "_feature_circle_hover", dataset.id + "_feature_circle_active", dataset.id + "_cluster_circle", dataset.id + "_cluster_label", "feature_icon", "feature_icon_hover", "feature_icon_active", THREED_LAYER_ID, THREED_LAYER_PLACEHOLDER_ID
    // `3d-models-layer`
    ];

    var theDatasetConfigs = datasetsLayers.find(function (_) {
      return _.id === dataset.id;
    });
    if (theDatasetConfigs) {
      theDatasetConfigs.layers.forEach(function (layerConfig) {
        if (layerConfig.id === 'custom') {
          tmp.push(layerConfig.customId);
        }
      });
    }
    return tmp;
  }, [dataset, datasetsLayers]);
  var closeSecondaryLayerLayer = useCallback(function () {
    var node = document.getElementById('mobilePopupContainer');
    node && ReactDOM.unmountComponentAtNode(node);
  }, []);
  useMemo(function () {
    if (mapboxAccessToken) {
      mapboxgl.accessToken = mapboxAccessToken;
    }
  }, [mapboxgl.accessToken, mapboxAccessToken]);
  useEffect(function () {
    if (map.current && map.current.loaded() && isSidebarCollapsable) {
      //TODO: refactor this to move to the app
      map.current.resize();
    }
  });
  useEffect(function () {
    dispatch(appLayoutModeDone(isMobile));
  }, [isMobile]);
  useEffect(function () {
    var handleMapParams = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _project$configs, _project$configs2;
        var mapParam, _project$configs3, _project$configs3$url, _project$configs3$url2, customParamsSource, customParamsMap, paramName, urlCustomParam, value;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              mapParam = getHash('map', false);
              if (mapParam) {
                setUrlCoords(mapParam);
              }
              if (!(((_project$configs = project.configs) === null || _project$configs === void 0 ? void 0 : _project$configs.urlParameter) && !Array.isArray((_project$configs2 = project.configs) === null || _project$configs2 === void 0 ? void 0 : _project$configs2.urlParameter))) {
                _context.next = 8;
                break;
              }
              customParamsSource = mprApiUrl + "/projects/" + project.configs.domain + "/asset/" + ((_project$configs3 = project.configs) === null || _project$configs3 === void 0 ? void 0 : (_project$configs3$url = _project$configs3.urlParameter) === null || _project$configs3$url === void 0 ? void 0 : (_project$configs3$url2 = _project$configs3$url.file) === null || _project$configs3$url2 === void 0 ? void 0 : _project$configs3$url2.filePath.split('/' + project.configs.domain + '/').join(''));
              _context.next = 6;
              return getCustomUrlParamList(customParamsSource);
            case 6:
              customParamsMap = _context.sent;
              if (customParamsMap) {
                paramName = customParamsMap.param;
                urlCustomParam = getHash(paramName, false);
                if (urlCustomParam) {
                  value = customParamsMap.values.find(function (_) {
                    return _.value === urlCustomParam;
                  });
                  setUrlParamName(paramName);
                  if (value) {
                    setUrlCoords(value.zoom + "/" + value.location.lat + "/" + value.location.lon);
                  }
                }
              }
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function handleMapParams() {
        return _ref.apply(this, arguments);
      };
    }();
    handleMapParams();
  }, []);
  useEffect(function () {
    var loadCityModels = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var os, cityModelsToLoad, loadedCityModels;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              os = getMobileOperatingSystem();
              cityModelsToLoad = [];
              _context2.t0 = os;
              _context2.next = _context2.t0 === 'iOS' ? 5 : _context2.t0 === 'Android' ? 7 : 9;
              break;
            case 5:
              cityModelsToLoad = cityModelsIos && cityModelsIos.length > 0 ? cityModelsIos : cityModels;
              return _context2.abrupt("break", 11);
            case 7:
              cityModelsToLoad = cityModelsAndroid && cityModelsAndroid.length > 0 ? cityModelsAndroid : cityModels;
              return _context2.abrupt("break", 11);
            case 9:
              cityModelsToLoad = cityModels;
              return _context2.abrupt("break", 11);
            case 11:
              _context2.next = 13;
              return getCityModels(cityModelsToLoad);
            case 13:
              loadedCityModels = _context2.sent;
              setCityModelsList(loadedCityModels);
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function loadCityModels() {
        return _ref2.apply(this, arguments);
      };
    }();
    loadCityModels();
    return function () {};
  }, []);
  useEffect(function () {
    var _project$configs4, _project$configs4$map;
    if (!selectedMapViewFilter) {
      return;
    }
    var point = (_project$configs4 = project.configs) === null || _project$configs4 === void 0 ? void 0 : (_project$configs4$map = _project$configs4.mapViewFilter) === null || _project$configs4$map === void 0 ? void 0 : _project$configs4$map.filter(function (_) {
      return _.label === selectedMapViewFilter;
    })[0];
    point && map.current.flyTo({
      center: point.center,
      zoom: point.zoom
    });
  }, [selectedMapViewFilter]);
  var removeTargomo = function removeTargomo() {
    map.current.setPaintProperty('isochronePolygons', 'fill-extrusion-height', 0);
    map.current.setPaintProperty('isochronePolygons', 'fill-extrusion-color', '#000000');
    map.current.setPaintProperty('isochronePolygons', 'fill-extrusion-opacity', 0);
  };
  useEffect(function () {
    if (geocoderEnabled && geocoderSelectedItem && popup && marker) {
      popup.remove();
      ReactDOM.unmountComponentAtNode(geocoderPopupContentElm);
      dispatch(geocoderClear());
      marker.remove();
    }
  }, [geocoderSelectedItem, geocoderEnabled]);
  var resizeMap = useCallback(function () {
    setTimeout(function () {
      map.current && map.current.resize();
    }, 200);
  }, [map.current]);
  useEffect(function () {
    var defaultUrl = url;
    var params = {
      container: ref.current,
      style: defaultUrl,
      center: [lng, lat],
      zoom: zoom,
      minZoom: minZoom,
      maxZoom: maxZoom,
      antialias: true,
      hash: 'map',
      maxPitch: maxPitch,
      minPitch: zoom >= 15 ? minPitch : 0,
      fadeDuration: 0,
      pitch: zoom >= 15 ? pitch : 0,
      attributionControl: false
    };
    var fogParams = {
      range: [5, 10],
      'horizon-blend': 0.1,
      'high-color': '#add8e6',
      'space-color': '#d8f2ff',
      'star-intensity': 0.0
    };
    var skyParams = {
      id: 'sky',
      type: 'sky',
      paint: {
        'sky-type': 'atmosphere',
        'sky-atmosphere-sun': [0.0, 0.0],
        'sky-atmosphere-sun-intensity': 15
      }
    };
    var isochroneParams = {
      id: 'isochronePolygons',
      type: 'fill-extrusion',
      layout: {},
      source: 'polygon',
      paint: {
        'fill-extrusion-base': 0
      }
    };
    var bounding = boundingBox && !!boundingBox.swLat && !!boundingBox.swLon && !!boundingBox.neLat && !!boundingBox.neLon && [[boundingBox.swLat, boundingBox.swLon], [boundingBox.neLat, boundingBox.neLon]];
    if (boundingBox) {
      params['maxBounds'] = bounding;
    }
    map.current = new mapboxgl.Map(params);
    MapInstance.configure({
      map: map.current
    });
    addAttributionControl(map.current);
    map.current.addControl(new mapboxgl.ScaleControl(), 'bottom-right');
    map.current.on('load', function () {
      var _project$configs5;
      {
        mapIcons && mapIcons.map(function (icon) {
          var _iconMapping$find;
          var iconName = icon.name.substring(0, icon.name.lastIndexOf('.'));
          var isIconSizeOriginal = iconMapping && ((_iconMapping$find = iconMapping.find(function (item) {
            return item.iconName === iconName;
          })) === null || _iconMapping$find === void 0 ? void 0 : _iconMapping$find.useOriginal);
          if (!map.current.hasImage(iconName)) {
            var iconUrl = mprApiUrl + "/projects/" + project.configs.domain + "/image/" + (isIconSizeOriginal ? '100x100' : '32x32') + "/" + icon.image.filePath.split('/' + project.configs.domain + '/').join('');
            map.current.loadImage(iconUrl, function (error, image) {
              if (error) {
                throw error;
              }
              map.current.addImage(iconName, image);
            });
          }
        });
      }
      var currentBasemap = basemaps.find(function (_) {
        return _.url === defaultUrl;
      });
      if (currentBasemap === null || currentBasemap === void 0 ? void 0 : currentBasemap.extrudedBuildings) {
        add3dBuildingsLayer(map.current, currentBasemap);
      } else {
        remove3DBuildingsLayer(map.current);
      }
      if ((_project$configs5 = project.configs) === null || _project$configs5 === void 0 ? void 0 : _project$configs5.mapTerrain) {
        var terrain = project.configs.mapTerrain;
        if (terrain.id !== '' && terrain.source !== null && terrain.exaggeration !== null) {
          map.current.addSource(terrain.id, terrain.source);
          map.current.setTerrain({
            source: terrain.id,
            exaggeration: terrain.exaggeration
          });
        }
      }
      var emptyData = {
        type: 'FeatureCollection',
        features: []
      };
      map.current.addSource('polygon', {
        type: 'geojson',
        data: emptyData
      });
      map.current.addLayer({
        id: THREED_LAYER_PLACEHOLDER_ID,
        type: 'custom',
        onAdd: function onAdd() {
          console.log('Added buildings layer placeholder');
        },
        render: function render() {}
      });
      secondaryLayers && secondaryLayers.map(function (section) {
        var _section$secondaryLay;
        section === null || section === void 0 ? void 0 : (_section$secondaryLay = section.secondaryLayers) === null || _section$secondaryLay === void 0 ? void 0 : _section$secondaryLay.map(function (layer) {
          return addLayer(map.current, layer, activeSecondaryLayers);
        });
      });
      streetViewLayers && streetViewLayers.map(function (layer) {
        return addLayer(map.current, layer, activeStreetViewLayers);
      });
      datasetsLayers.map(function (datasetLayers) {
        setDataSetSource({
          map: map.current,
          datasetId: datasetLayers.id,
          projectId: project.id,
          datasetFields: dataset.fields,
          datasetRequiredFields: dataset.requiredFields,
          selectedValues: selectedValues,
          searchMasks: searchMasks,
          lang: language,
          isCluster: datasetLayers.cluster,
          iconFieldName: iconFieldName,
          filterLogic: filterLogic,
          filtersMap: filtersMap,
          tileUrl: mprTileUrl
        });
        addDataSetLayer({
          map: map.current,
          datasetId: datasetLayers.id,
          selectItem: function selectItem(guid) {
            if (getHash('journey')) {
              setHash('journey', '');
              dispatch(journeyDeselectStart());
            }
            setHash('selectedItem', guid);
            dispatch(dataItemLoad({
              guid: guid,
              interactionType: 'select'
            }));
          },
          deselectItem: function deselectItem() {
            setHash('selectedItem', '');
            dispatch(dataItemDeselect());
            if (showTargomoSwitch && map.current.getLayer('isochronePolygons')) {
              removeTargomo();
            }
          },
          hoverItem: function hoverItem(guid) {
            dispatch(dataItemHover({
              guid: guid,
              interactionType: 'hover'
            }));
          },
          hoverOffItem: function hoverOffItem(guid) {
            dispatch(dataItemHoverOff());
          },
          generateShortUrl: function generateShortUrl() {
            dispatch(_generateShortUrl(location.href));
          },
          urlChangeEvent: 'url-change-event',
          itemChangeEvent: 'selected-item-change-event',
          itemHoverEvent: 'hovered-item-change-event',
          selectedItem: getHash('selectedItem'),
          PopUpComponent: PopUpComponent,
          showPopup: showPopup,
          layers: datasetLayers.layers,
          isMobile: isMobile,
          history: history,
          lang: language,
          locale: language,
          projectConfigs: project.configs,
          domain: project.configs.domain,
          displayDatasetLayerIcons: displayDatasetLayerIcons,
          iconMapping: iconMapping,
          iconFieldName: iconFieldName,
          mprApiUrl: mprApiUrl
        });
      });
      var currentZoom = map.current.getZoom();
      if (currentZoom < 15) {
        map.current.dragRotate.disable();
        map.current.touchZoomRotate.disableRotation();
      } else {
        map.current.dragRotate.enable();
        map.current.touchZoomRotate.enableRotation();
      }
      !map.current.getLayer(skyParams.id) && map.current.addLayer(skyParams);
      !map.current.getLayer('isochronePolygons') && showTargomoSwitch && !isMobile && map.current.addLayer(isochroneParams);
      map.current.setFog(fogParams);
      setMoveInitiator('map');
      setMapReady(true);
      setMapLoaded(true);
    });
    map.current.on('contextmenu', function (e) {});

    //map init....
    // const resizer = new ResizeObserver(debounce(resizeMap, 400));
    // const resizer = new ResizeObserver(resizeMap);
    // resizer.observe(ref.current);

    return function () {
      // resizer.disconnect();
      map.current.remove();
      map.current = null;
    };
  }, []);
  useEffect(function () {
    if (map.current) {
      map.current.on('style.load', function () {
        {
          mapIcons && mapIcons.forEach(function (icon) {
            var _iconMapping$find2;
            var iconName = icon.name.substring(0, icon.name.lastIndexOf('.'));
            var isIconSizeOriginal = (_iconMapping$find2 = iconMapping.find(function (item) {
              return item.iconName === iconName;
            })) === null || _iconMapping$find2 === void 0 ? void 0 : _iconMapping$find2.useOriginal;
            if (!map.current.hasImage(iconName)) {
              var iconUrl = mprApiUrl + "/projects/" + project.configs.domain + "/image/" + (isIconSizeOriginal ? '100x100' : '32x32') + "/" + icon.image.filePath.split('/' + project.configs.domain + '/').join('');
              map.current.loadImage(iconUrl, function (error, image) {
                if (error) {
                  throw error;
                }
                map.current.addImage(iconName, image);
              });
            }
          });
        }
      });
    }
  }, [map.current]);

  // useEffect(() => {
  //   if (ref.current && !map.current) {
  //     // addMapGeocoderControl();

  //   }
  // }, [ref, lat, lng, zoom, url, map.current]);

  var addThreeDLayer = useCallback(function () {
    if (map.current && !threeDLayer.current && cityModelsList && models && map.current.getLayer(THREED_LAYER_PLACEHOLDER_ID)) {
      var formattedModels = models.map(function (m) {
        var model = m.model;
        var positions = [];
        if (model.positions) {
          positions = [].concat(model.positions);
        } else {
          positions.push({
            center: model.center,
            altitude: model.altitude,
            scale: model.scale,
            rotate: model.rotate
          });
        }
        return _extends({}, model, {
          middleZoomLevel: model.middleZoomLevel || ((model.maxZoomLevel || 22) + model.minZoomLevel) / 2,
          maxZoomLevel: model.maxZoomLevel || 22,
          minZoomLevel: model.minZoomLevel,
          positions: positions
        });
      });
      threeDLayer.current = {
        id: THREED_LAYER_ID,
        type: 'custom',
        renderingMode: '3d',
        onAdd: function onAdd(map, gl) {
          threeDUtils.onAdd(THREED_LAYER_ID, {
            meshColor: '#FFFFFF',
            meshInterval: 100,
            textureInterval: 1,
            mobileModel: false,
            activeModelGroup: 0,
            globalModelToggle: false,
            methods: {
              selectPOIWithModelId: selectPOIWithModelId
            }
          }, [formattedModels], [], cityModelsList, map, gl, false, isMobile ? initiallyShowThreeDMobile !== false : initiallyShowThreeD !== false);
        },
        render: function render(gl, matrix) {
          threeDUtils.render(THREED_LAYER_ID, gl, matrix);
        },
        onRemove: function onRemove(map, gl) {
          threeDUtils.onRemove(map, gl);
        }
      };
      map.current.addLayer(threeDLayer.current, THREED_LAYER_PLACEHOLDER_ID);
    }
  }, [map.current, cityModelsList, (_map$current = map.current) === null || _map$current === void 0 ? void 0 : _map$current.getLayer(THREED_LAYER_PLACEHOLDER_ID)]);
  var zoomHandler = useCallback(function () {
    var currentZoom = map.current.getZoom();
    if (currentZoom < 15 && (!lastZoom.current || lastZoom.current >= 15)) {
      map.current.dragRotate.disable();
      map.current.touchZoomRotate.disableRotation();
      map.current.setMinPitch(0);
      map.current.flyTo({
        bearing: 0,
        pitch: 0
      });
      setFlying(true);
      if (compassControl.current) {
        removeMapCompassControl(map.current, compassControl.current);
      }
    } else if (currentZoom >= 15 && (!lastZoom.current || lastZoom.current < 15)) {
      map.current.flyTo({
        pitch: pitch
      });
      setTimeout(function () {
        map.current.setMinPitch(minPitch);
      }, 300);
      map.current.dragRotate.enable();
      map.current.touchZoomRotate.enableRotation();
      compassControl.current = addMapCompassControl(ref.current, props, map.current);
    }
    lastZoom.current = currentZoom;
  }, [map.current, lastZoom.current, compassControl.current, removeMapCompassControl, minPitch, ref.current, props]);
  useEffect(function () {
    if (map.current) {
      addThreeDLayer();
      map.current.off('moveend');
      map.current.on('moveend', function () {
        if (moveInitiator.current !== 'data' || moveInitiator.current !== 'map') {
          var bounds = map.current.getBounds();
          var bbox = [bounds._sw.lng, bounds._sw.lat, bounds._ne.lng, bounds._ne.lat];
          !isMobile && isBboxIncluded && dispatch(changeMapBbox({
            bbox: bbox,
            userMove: true
          }));
        }
        setMoveInitiator('');
      });
    }
  }, [map.current, threeDLayer.current, mapLoaded, geocoderSelectedItem, geocoderEnabled, cityModelsList]);
  useEffect(function () {
    if (map.current) {
      map.current.off('zoomend');
      map.current.on('zoomend', function () {
        zoomHandler();
      });
    }
    return function () {
      map.current && map.current.off('zoomend');
    };
  }, [map.current]);
  useEffect(function () {
    var urlChangeEvent = new CustomEvent('url-change-event', {
      detail: {
        shortUrl: shortUrl
      }
    });
    document.dispatchEvent(urlChangeEvent);
  }, [shortUrl]);
  useEffect(function () {
    if (!map.current || !secondaryLayers || !mapLoaded) {
      return;
    }
    secondaryLayers.map(function (section) {
      section.secondaryLayers.map(function (secondaryLayer) {
        secondaryLayer === null || secondaryLayer === void 0 ? void 0 : secondaryLayer.layers.map(function (layer) {
          if (!layer.id.includes(':active')) {
            if (activeSecondaryLayers.includes(secondaryLayer.name)) {
              map.current.setLayoutProperty("" + layer.id, 'visibility', 'visible');
            } else {
              map.current.setLayoutProperty("" + layer.id, 'visibility', 'none');
              map.current.setFilter(layer.id, null);
              if (typeof map.current.getLayer(layer.id + ":active") !== 'undefined') {
                map.current.setLayoutProperty(layer.id + ":active", 'visibility', 'none');
              }
            }
          }
        });
      });
    });
    if (isMobile) {
      var node = document.getElementById('mobilePopupContainer');
      node && ReactDOM.unmountComponentAtNode(node);
    } else {
      var _popup = document.getElementsByClassName('mapboxgl-popup');
      if (_popup.length) {
        _popup[0].remove();
      }
    }
  }, [activeSecondaryLayers, map.current, mapLoaded]);
  useEffect(function () {
    if (!map.current || !streetViewLayers || !mapLoaded) {
      return;
    }
    streetViewLayers.map(function (layersGroup) {
      layersGroup === null || layersGroup === void 0 ? void 0 : layersGroup.layers.map(function (layer) {
        if (!layer.id.includes(':active')) {
          if (activeStreetViewLayers) {
            map.current.setLayoutProperty("" + layer.id, 'visibility', 'visible');
          } else {
            map.current.setLayoutProperty("" + layer.id, 'visibility', 'none');
            map.current.setFilter(layer.id, null);
            if (typeof map.current.getLayer(layer.id + ":active") !== 'undefined') {
              map.current.setLayoutProperty(layer.id + ":active", 'visibility', 'none');
            }
          }
        }
      });
    });
    if (isMobile) {
      var node = document.getElementById('mobilePopupContainer');
      node && ReactDOM.unmountComponentAtNode(node);
    } else {
      var _popup2 = document.getElementsByClassName('mapboxgl-popup');
      if (_popup2.length) {
        _popup2[0].remove();
      }
    }
  }, [activeStreetViewLayers, map.current, mapLoaded]);
  useEffect(function () {
    // if (!map.current || !mapLoaded) {
    //   return;
    // }

    if (Object.keys(journeys).length === 0) {
      removeJourneysLayer(map.current);
    } else {
      addJourneysLayer(map.current, journeys);
    }
  }, [map.current, journeys]);
  useEffect(function () {
    if (!map.current || !mapLoaded) {
      return;
    }
    basemaps.map(function (basemap) {
      if (basemap.name === activeBasemap && basemap.url !== url) {
        var layers = [];
        secondaryLayers && secondaryLayers.forEach(function (section) {
          var _section$secondaryLay2;
          return section === null || section === void 0 ? void 0 : (_section$secondaryLay2 = section.secondaryLayers) === null || _section$secondaryLay2 === void 0 ? void 0 : _section$secondaryLay2.forEach(function (secLayer) {
            return secLayer.layers.forEach(function (layer) {
              return layers.push(layer.id);
            });
          });
        });
        onBasemapChange && onBasemapChange();
        switchBasemap(map.current, basemap.url.replace('mapbox://styles/', ''), mapboxgl.accessToken, layers, datasetLayersNames);
      }
    });
  }, [activeBasemap, map.current, mapLoaded, onBasemapChange, datasetLayersNames]);
  useEffect(function () {
    if (moveInitiator.current !== 'map') {
      setMoveInitiator('data');
    }
  }, [selectedValues, searchLoading]);
  useEffect(function () {
    mapLoaded && setTimeout(function () {
      updateDatasetSource({
        map: map.current,
        datasetId: dataset.id,
        selectedValues: selectedValues,
        searchMasks: searchMasks,
        lang: language,
        filterLogic: filterLogic,
        filtersMap: filtersMap
      });
    }, 0);
  }, [selectedValues, searchMasks, searchLoading, mapLoaded, map.current]);
  useEffect(function () {
    var _datasetBbox$coordina;
    if (map.current && (datasetBbox === null || datasetBbox === void 0 ? void 0 : (_datasetBbox$coordina = datasetBbox.coordinates) === null || _datasetBbox$coordina === void 0 ? void 0 : _datasetBbox$coordina.length) > 0 && moveInitiator.current === 'data' && (project.configs.zoomOnFilterToggle || typeof project.configs.zoomOnFilterToggle !== 'boolean')) {
      map.current.fitBounds(turf.bbox(datasetBbox), {
        padding: 20
      });
    }
    setMoveInitiator('');
  }, [datasetBbox]);
  useEffect(function () {
    if (!map.current || !mapLoaded) {
      return;
    }
    if (selectedItem) {
      var center = map.current.getCenter();
      setLastPosition({
        center: [center.lng, center.lat],
        zoom: map.current.getZoom(),
        pitch: map.current.getPitch(),
        bearing: map.current.getBearing()
      });
    }
    if (project.configs.zoomOnPOISelect || typeof project.configs.zoomOnPOISelect !== 'boolean') {
      var _selectedItem$geometr;
      var options = selectedItem ? {
        center: selectedItem === null || selectedItem === void 0 ? void 0 : (_selectedItem$geometr = selectedItem.geometry) === null || _selectedItem$geometr === void 0 ? void 0 : _selectedItem$geometr.coordinates,
        zoom: 16
      } : lastPosition;
      setTimeout(function () {
        map.current.flyTo(_extends({}, options, {
          essential: true
        }));
      }, 20);
    }

    // const urlChangeEvent = new CustomEvent('selected-item-change-event', {
    //   detail: {
    //     selectedItem,
    //   },
    // });
    // document.dispatchEvent(urlChangeEvent);
  }, [selectedItem, mapLoaded]);
  useEffect(function () {
    var urlChangeEvent = new CustomEvent('selected-item-change-event', {
      detail: {
        selectedItem: selectedItem
      }
    });
    document.dispatchEvent(urlChangeEvent);
  }, [selectedItem]);
  useEffect(function () {
    if (!map.current || !mapLoaded) {
      return;
    }
    var urlChangeEvent = new CustomEvent('hovered-item-change-event', {
      detail: {
        hoveredItem: hoveredItem
      }
    });
    document.dispatchEvent(urlChangeEvent);
  }, [hoveredItem, mapLoaded]);
  useEffect(function () {
    if (!streetViewLayers || !map.current) {
      return;
    }
    var layers = [];
    var activeLayers = {};
    var interactiveLayers = [];
    streetViewLayers.map(function (layersGroup) {
      layersGroup === null || layersGroup === void 0 ? void 0 : layersGroup.layers.map(function (layer) {
        if (!layer.id.includes(':active')) {
          layers = [].concat(layers, [layer.id]);
        }
      });
      activeLayers = _extends({}, activeLayers, layersGroup === null || layersGroup === void 0 ? void 0 : layersGroup.activeLayers);
      interactiveLayers = [].concat(interactiveLayers, layersGroup ? layersGroup.interactiveLayers : []);
    });
    map.current.on('click', function (e) {
      var _features$0$propertie;
      var features = map.current.queryRenderedFeatures(e.point, {
        layers: interactiveLayers
      });
      features[0] && openStreetViewModal(_extends({}, features[0], {
        properties: _extends({}, features[0], {
          URL: (_features$0$propertie = features[0].properties.URL) !== null && _features$0$propertie !== void 0 ? _features$0$propertie : "https://www.mapillary.com/embed?image_key=" + features[0].properties.id + "&style=photo"
        })
      }));
    });
    map.current.on('mousemove', layers, function () {
      map.current.getCanvasContainer().style.cursor = 'pointer';
    });
    map.current.on('mouseleave', layers, function () {
      map.current.getCanvasContainer().style.cursor = '';
    });
  }, [streetViewLayers, map.current]);
  var _useState8 = useState(false),
    isPopupOpen = _useState8[0],
    setIsPopupOpen = _useState8[1];
  var isHoverLayer = false;
  useEffect(function () {
    if (map.current) {
      map.current.on('mouseup', function (e) {
        if (getHash(urlParamName, false)) {
          setHash(urlParamName, '');
          setUrlParamName(null);
        }
      });
    }
  }, [flying, map.current]);
  useEffect(function () {
    if (!secondaryLayers || !mapLoaded) {
      return;
    }
    var layers = [];
    var activeLayers = {};
    var clickLayers = [];
    var hoverLayers = [];
    secondaryLayers.forEach(function (section) {
      section.secondaryLayers.forEach(function (secondaryLayer) {
        secondaryLayer === null || secondaryLayer === void 0 ? void 0 : secondaryLayer.layers.forEach(function (layer) {
          if (!layer.id.includes(':active')) {
            layers.push(layer.id);
          }
          switch (secondaryLayer.popupEvent) {
            case 'click':
              clickLayers.push(layer.id);
              break;
            case 'hover':
              hoverLayers.push(layer.id);
              break;
            default:
              clickLayers.push(layer.id);
              break;
          }
        });
        activeLayers[section] = _extends({}, activeLayers[section], secondaryLayer === null || secondaryLayer === void 0 ? void 0 : secondaryLayer.activeLayers);
      });
    });
    var popUpLayers = [].concat(layers);
    ['_feature_circle_default', '_cluster_circle'].forEach(function (suffix) {
      var layerId = "" + dataset.id + suffix;
      if (map.current.getLayer(layerId)) {
        popUpLayers.push(layerId);
      }
    });
    var handlePopupClose = function handlePopupClose() {
      if (isMobile) {
        var node = document.getElementById('mobilePopupContainer');
        node && ReactDOM.unmountComponentAtNode(node);
      } else {
        var _popup3 = document.getElementsByClassName('mapboxgl-popup');
        if (_popup3.length) {
          var markerCircle = document.getElementsByClassName('marker')[0];
          if (markerCircle !== undefined) {
            markerCircle.style.display = 'none';
            marker.remove();
          }
          _popup3[0].remove();
          setIsPopupOpen(false);
        }
      }
    };
    var handlePopupOpen = function handlePopupOpen(e, layerId) {
      var features = map.current.queryRenderedFeatures(e.point, {
        layers: popUpLayers
      });
      if (!features.length) {
        return;
      }
      var fields = activeLayers[layerId];
      var properties = features[0].properties;
      var property = (fields === null || fields === void 0 ? void 0 : fields.includes('properties')) ? fields.split('.')[1] : fields;
      handlePopupClose();
      var group = findGroupByLayerId(layerId);
      if (layers.includes(layerId) && (fields || (group === null || group === void 0 ? void 0 : group.customPopUp))) {
        var popUpNode = isMobile ? document.getElementById('mobilePopupContainer') : document.createElement('div');
        popUpNode.classList.add('selected-popup');
        ReactDOM.render( /*#__PURE__*/React.createElement(SecondaryLayerPopUpComponent, {
          properties: properties,
          locale: language,
          layerID: layerId,
          layersGroup: group,
          projectConfigs: project.configs,
          fields: fields,
          onClose: handlePopupClose
        }), popUpNode);
        popUpNode.addEventListener('wheel', function (event) {
          map.current.scrollZoom.wheel(event);
        });
        if (!isMobile && !isPopupOpen) {
          new mapboxgl.Popup({
            closeButton: true
          }).setLngLat(e.lngLat).setDOMContent(popUpNode).addTo(map.current);
          setIsPopupOpen(true);
        }
      }
      if (map.current.getLayer(layerId + ":active")) {
        if (properties[property]) {
          map.current.setFilter(layerId + ":active", ['==', property, properties[property]]);
          map.current.setFilter(layerId, ['!=', property, properties[property]]);
          map.current.setLayoutProperty(layerId + ":active", 'visibility', 'visible');
          layers.forEach(function (layer) {
            if (layer !== layerId) {
              map.current.setFilter(layer, null);
              var activeLayer = map.current.getLayer(layer + ":active");
              if (activeLayer) {
                map.current.setLayoutProperty(layer + ":active", 'visibility', 'none');
              }
            }
          });
        } else {
          map.current.setFilter(layerId, null);
          map.current.setLayoutProperty(layerId + ":active", 'visibility', 'none');
        }
      }
    };
    var handleMousemove = function handleMousemove(e) {
      var _features$, _features$$layer;
      map.current.getCanvasContainer().style.cursor = 'pointer';
      var features = map.current.queryRenderedFeatures(e.point, {
        layers: hoverLayers
      });
      var layerId = (_features$ = features[0]) === null || _features$ === void 0 ? void 0 : (_features$$layer = _features$.layer) === null || _features$$layer === void 0 ? void 0 : _features$$layer.id;
      if (hoverLayers.includes(layerId)) {
        isHoverLayer = true;
        handlePopupOpen(e, layerId);
      }
    };
    var handleMouseleave = function handleMouseleave() {
      map.current.getCanvasContainer().style.cursor = '';
      if (isHoverLayer) {
        isHoverLayer = false;
        handlePopupClose();
      }
    };
    map.current.on('click', function (e) {
      var _features$2, _features$2$layer;
      var features = map.current.queryRenderedFeatures(e.point, {
        layers: clickLayers
      });
      var layerId = (_features$2 = features[0]) === null || _features$2 === void 0 ? void 0 : (_features$2$layer = _features$2.layer) === null || _features$2$layer === void 0 ? void 0 : _features$2$layer.id;
      var group = findGroupByLayerId(layerId);
      if (clickLayers.includes(layerId)) {
        isHoverLayer = false;
        handlePopupOpen(e, layerId, group);
      }
    });
    map.current.on('mousemove', layers, handleMousemove);
    map.current.on('mouseleave', layers, handleMouseleave);
  }, [secondaryLayers, mapLoaded]);
  var findGroupByLayerId = function findGroupByLayerId(layerId) {
    for (var _iterator = _createForOfIteratorHelperLoose(secondaryLayers), _step; !(_step = _iterator()).done;) {
      var section = _step.value;
      for (var _iterator2 = _createForOfIteratorHelperLoose(section.secondaryLayers), _step2; !(_step2 = _iterator2()).done;) {
        var secondaryLayer = _step2.value;
        for (var _iterator3 = _createForOfIteratorHelperLoose(secondaryLayer.layers), _step3; !(_step3 = _iterator3()).done;) {
          var layer = _step3.value;
          if (layer.id === layerId) {
            return secondaryLayer;
          }
        }
      }
    }
    return null;
  };
  useEffect(function () {
    if (!mapLoaded || !geocoderEnabled) {
      return;
    }
    if (geocoderPopupComponent && geocoderSelectedItem) {
      var markerCircle = document.getElementsByClassName('marker')[0];
      markerCircle.style.display = 'block';
      popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false
      }).setLngLat([geocoderSelectedItem.center[0], geocoderSelectedItem.center[1]]);
      marker = new mapboxgl.Marker().setLngLat([geocoderSelectedItem.center[0], geocoderSelectedItem.center[1]]).addTo(map.current);
      var Tag = geocoderPopupComponent;
      var element = /*#__PURE__*/React.createElement(Tag, {
        key: geocoderSelectedItem.id,
        item: geocoderSelectedItem,
        onClose: function onClose() {
          onGeocoderClear();
        }
      });
      geocoderPopupContentElm = document.createElement('div');
      geocoderPopupContentElm.id = 'mpr-popup-content';
      ReactDOM.render(element, geocoderPopupContentElm);
      popup.setDOMContent(geocoderPopupContentElm).addTo(map.current);
    }
  }, [geocoderSelectedItem, geocoderEnabled, mapLoaded]);
  useEffect(function () {
    if (!map.current || !mapLoaded) {
      return;
    }
    var geocoderHandlers = geocoderEnabled ? {
      // results: ({ features }) => dispatch(geocoderSearchDone(features)),
      result: function result(_ref3) {
        var _result = _ref3.result;
        return dispatch(geocoderSelectDone(_result));
      },
      error: function error(_ref4) {
        var _error = _ref4.error;
        return dispatch(geocoderSearchFail(_error));
      }
    } : undefined;
    addMapControls(ref.current, map.current, mapboxgl.accessToken, geocoderEnabled, geocoderHandlers, geocoderCountries, props, language);
  }, [map.current, mapLoaded]);
  useEffect(function () {
    if (!mapLoaded) {
      return;
    }
    if (urlCoords && !selectedItem) {
      var coords = urlCoords.split('/');
      setTimeout(function () {
        map.current.flyTo({
          center: [coords[2], coords[1]],
          zoom: coords[0],
          bearing: coords[0] >= 15 && (coords === null || coords === void 0 ? void 0 : coords[3]) || 0,
          pitch: coords[0] >= 15 && (coords === null || coords === void 0 ? void 0 : coords[4]) || 0
        });
        if (coords[0] >= 15) {
          map.current.dragRotate.enable();
          map.current.touchZoomRotate.enableRotation();
          // compasControl = addMapCompasControl(ref.current, props, map.current);
        }
      }, 20);
    }
    if (isMobile || !isBboxIncluded) {
      dispatch(dataItemsLoad());
    }
  }, [mapLoaded]);
  useEffect(function () {
    if (showPolygonSwitch && !isMobile) {
      addMapDrawControl(MapboxDraw, map.current, turf, project.configs.primaryColor, language, function (data) {
        dispatch(mapDraw(data));
      });
    }
  }, []);
  var selectPOIWithModelId = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(modelId) {
      var query, result, guid;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            query = ['match', '3d_models', modelId];
            _context3.prev = 1;
            _context3.next = 4;
            return ApolloClient.query(itemQuery, {
              dataSetId: dataset.id,
              projectId: project.id,
              query: query
            });
          case 4:
            result = _context3.sent;
            guid = result.data.dataset.data.items[0].guid;
            dispatch(dataItemLoad({
              guid: guid
            }));
            _context3.next = 12;
            break;
          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](1);
            console.log(_context3.t0);
          case 12:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[1, 9]]);
    }));
    return function selectPOIWithModelId(_x) {
      return _ref5.apply(this, arguments);
    };
  }();
  var onGeocoderClear = function onGeocoderClear() {
    var markerCircle = document.getElementsByClassName('marker')[0];
    markerCircle.style.display = 'none';
    popup.remove();
    marker.remove();
    ReactDOM.unmountComponentAtNode(geocoderPopupContentElm);
    dispatch(geocoderClear());
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: "Map",
    style: {
      width: '100%',
      height: '100%'
    }
  });
}
Map.propTypes = process.env.NODE_ENV !== "production" ? {
  url: PropTypes.string.isRequired,
  lng: PropTypes.number.isRequired,
  lat: PropTypes.number.isRequired,
  zoom: PropTypes.number.isRequired,
  minZoom: PropTypes.number.isRequired,
  maxZoom: PropTypes.number.isRequired,
  boundingBox: PropTypes.shape({
    neLat: PropTypes.number,
    neLon: PropTypes.number,
    swLat: PropTypes.number,
    swLon: PropTypes.number
  }),
  models: PropTypes.array,
  isMobile: PropTypes.bool,
  isSidebarCollapsable: PropTypes.bool,
  history: PropTypes.object,
  isBboxIncluded: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  geocoderPopupComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  /**
   * A function that is used to identify that a Street view item has bin clicked. Tipically used for opening a new view with the street view iframe.
   * It passes through a single argument corresponding to the clicked item. This argument is an object with the following main properties:
   *
   * ```
   *
   * {
   *   id: string,
   *   properties: {
   *     URL: string
   *   }
   * }
   *
   * ```
   * Example usage: `openStreetViewModal={(feature) => setModalUrl(feature.properties.URL)}`
   * Here the setModalUrl method implies the functionality to open an iframe with the specified URL of a Street View tour.
   *
   * @function
   * @param {Object} feature
   * @returns {void}
   *
   */
  openStreetViewModal: PropTypes.func,
  setMapReady: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  onBasemapChange: PropTypes.func,
  /**
   * A function that desides if the popup of given type should be shown for given feature. Type can be either 'select' or 'hover'.
   * @function
   * @param {Object} item
   * @param {String} type
   * @returns {boolean}
   * */
  showPopup: PropTypes.func,
  pitch: PropTypes.number,
  minPitch: PropTypes.number,
  maxPitch: PropTypes.number,
  PopUpComponent: PropTypes.any,
  SecondaryLayerPopUpComponent: PropTypes.any
} : {};
Map.defaultProps = {
  url: 'mapbox://styles/bogdanvectuel/cit1mptgv00252xovd208thtz',
  lng: 2.2399971252104396,
  lat: 46.9996255187384,
  zoom: 5,
  minZoom: 8,
  maxZoom: 22,
  boundingBox: null,
  models: [],
  geocoderPopupComponent: function geocoderPopupComponent() {
    return null;
  },
  openStreetViewModal: function openStreetViewModal() {
    return null;
  },
  setMapReady: function setMapReady() {
    return null;
  },
  isBboxIncluded: true
};
export default Map;